import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
    return ( <
        div className = "App" >
        <
        div className = "container" >
        <
        Weather defaultCity = "New York" / >

        <
        footer >
        This project was coded by { " " } <
        a href = "https://www.facebook.com/KgomotsoMonga"
        target = "_blank"
        rel = "noopener noreferrer" >
        Kgomotso Salman <
        /a>{" "}
        and is { " " } <
        a href = "https://github.com/KgomotsoSalman/react-weather-app"
        target = "_blank"
        rel = "noopener noreferrer" >
        open - sourced on GitHub <
        /a>{" "}
        and { " " } <
        a href = "https://majestic-clafoutis-568c6f.netlify.app/"
        target = "_blank"
        rel = "noopener noreferrer" >
        hosted on Netlify <
        /a> < /
        footer > <
        /div> < /
        div >
    );
}